// A list of common ascii keycodes
export const keyCode = {
  escape: 27,
  enter: 13,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
}
